import { getNodeId } from '../store/actionHandlers/common/adapterActions';

/**
 * This filter is configured with a list of models that form a subtree.
 * Only those models are allowed which are part of this tree, or are
 * descendants of leaves of this tree.
 */
export default class SubtreeFilter {
  constructor({ nodeIsVisible = null } = {}) {
    this._nodeIsVisible = nodeIsVisible;
  }

  get key() {
    return 'filter';
  }

  prepareTreeState(treeState) {
    treeState.hiddenNodeIds = {};
  }

  handleDidUpdateTree(treeState, { adapter, plugins }) {
    treeState.hiddenNodeIds = refilter(treeState, adapter, this._nodeIsVisible);

    if (plugins?.selection?.syncSelectionStatuses) {
      plugins.selection.syncSelectionStatuses(treeState, { adapter });
    }
  }

  nodeIsVisible(treeState, nodeId) {
    return !treeState.hiddenNodeIds[nodeId];
  }
}

function refilter({ filter, models, children }, adapter, extraPredicate) {
  const hiddenNodeIds = {};

  if (filter && filter.length) {
    const subtreeIds = filter.reduce((set, model) => {
      set.add(getNodeId(adapter, model));
      return set;
    }, new Set());

    for (const subtreeModel of filter) {
      const childIds = children[getNodeId(adapter, subtreeModel)];
      if (!childIds || !childIds.length) {
        continue;
      }

      if (childIds.some(id => subtreeIds.has(id))) {
        for (const childId of childIds) {
          if (!subtreeIds.has(childId)) {
            hiddenNodeIds[childId] = true;
          }
        }
      }
    }

    for (const rootId of children.null) {
      if (!subtreeIds.has(rootId)) {
        hiddenNodeIds[rootId] = true;
      }
    }
  }

  if (extraPredicate) {
    for (const id of Object.keys(models)) {
      if (!extraPredicate(models[id])) {
        hiddenNodeIds[id] = true;
      }
    }
  }

  return hiddenNodeIds;
}
